module.exports = __webpack_public_path__ + "img/tortini-di-verdure.86c320f4.png";